import { TTabs } from '../../utils';
import { Tab } from './Tab/Tab';
import style from './Tabs.module.scss';
import { useTabs } from './TabsProvider';
import { PublishButton } from '../PublishButton/PublishButton';

type Props = {
  tabsList: TTabs;
  openPublishButton: () => void;
};

export const Tabs = ({ tabsList, openPublishButton }: Props) => {
  const { activeTab, setActiveTab } = useTabs();

  return (
    <div className={style.container}>
      {tabsList.map((name) => {
        return (
          <Tab
            key={name}
            setActiveTab={setActiveTab}
            name={name}
            active={name === activeTab}
          />
        );
      })}
      <PublishButton activeTab={activeTab} openPublishButton={openPublishButton} />
    </div>
  );
};
